import React from 'react';

interface IconShapeProps {
	/** Color of the shape (default: #EF4444) */
	color?: string;
	/** Width of the shape container (default: 78px for horizontal, 64px for vertical) */
	width?: string | number;
	/** Height of the shape container (default: 64px for horizontal, 78px for vertical) */
	height?: string | number;
	/** Rotation angle in degrees (default: -90 for horizontal layout, 0 for vertical) */
	rotation?: number;
	/** Additional CSS classes */
	className?: string;
	/** Additional inline styles */
	style?: React.CSSProperties;
	/** Children to render on top of the shape */
	children?: React.ReactNode;
}

export const IconShape: React.FC<IconShapeProps> = ({
	color = '#EF4444',
	width = 78,
	height = 64,
	rotation = -90,
	className = '',
	style = {},
	children
}) => {
	const widthValue = typeof width === 'number' ? `${width}px` : width;
	const heightValue = typeof height === 'number' ? `${height}px` : height;

	return (
		<div
			className={`relative flex items-center justify-center ${className}`}
			style={{ width: widthValue, height: heightValue, ...style }}
		>
			<svg
				className="absolute inset-0 w-full h-full"
				viewBox="0 0 64 78"
				preserveAspectRatio="xMidYMid meet"
				style={{
					transform: `rotate(${rotation}deg)`,
					transformOrigin: 'center'
				}}
			>
				<path
					d="m31.9999572 77.9709785.0000428.0290215-.0001713-.0580228c-.0244208-4.1360599-2.6581977-7.6496049-6.3283057-8.9552913-.806593-.1406323-1.6025-.3126356-2.385781-.5157241-.259109-.0213508-.521162-.0322366-.785742-.0322366l.657288.000004c-13.323444-3.4958727-23.157288-15.6885422-23.157288-30.192843 0-14.5068351 9.83728-26.7012306 23.164271-30.19467488l-.664271.00117554c.2673 0 .532022-.01111121.79308-.03464201.781353-.20119136 1.574592-.37250525 2.378483-.51115582 3.232279-1.15183268 5.660752-4.01454175 6.210809-7.50658903h.235256c.550057 3.49204728 2.97853 6.35475635 6.210809 7.50658903.803891.13865057 1.597129.30996446 2.378483.51115582.261057.0235308.525779.03464201.79308.03464201l-.664272-.00117554c13.326991 3.49344428 23.164272 15.68783978 23.164272 30.19467488 0 14.5043008-9.833845 26.6969703-23.157288 30.192843l.657288-.000004c-.26458 0-.526634.0108858-.785743.0322366-.78328.2030885-1.579188.3750918-2.385781.5157241-3.678682 1.3087371-6.3161856 4.8356619-6.3284332 8.9842926z"
					fill={color}
				/>
			</svg>
			{children && <div className="relative z-10">{children}</div>}
		</div>
	);
};

export default IconShape;

